import { render, staticRenderFns } from "./DownloadV5.vue?vue&type=template&id=5a7d4b1b&scoped=true"
import script from "./DownloadV5.vue?vue&type=script&lang=js"
export * from "./DownloadV5.vue?vue&type=script&lang=js"
import style0 from "./DownloadV5.vue?vue&type=style&index=0&id=5a7d4b1b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7d4b1b",
  null
  
)

export default component.exports